import { writable } from 'svelte/store';

export const createContext = () => writable({});